import React, {Component, Fragment} from 'react';

class RemotePage extends Component {
    constructor(props) {
        super(props);
    };

    state = {
        connectionCount: 0,
    };

    componentDidMount() {
        const {requestGetConnection} = this;
        requestGetConnection()
    }

    requestGetConnection = () => {
        // const {requestGetConnection} = this;
        fetch('/api', {
            method: 'post',
            headers: {'Content-type': 'application/json'},
            body: JSON.stringify({
                "data": {
                    category: 'private',
                    service: 'GetConnections',
                    access_token: '34a514e8dc0e11e9a29d02420aff012a',
                }
            })
        })
            .then(res => res.json())
            .then(json => {
                if (json.data) {
                    let connectionCount = 0;
                    let todayNewUserCount = 0;
                    let androidConnectionCount = 0;
                    let iosConnectionCount = 0;
                    let agentConnectionCount = 0;
                    if (json.data.connection_number) {
                        connectionCount = json.data.connection_number;
                    }
                    if (json.data.today_new_user_count) {
                        todayNewUserCount = json.data.today_new_user_count;
                    }
                    if (json.data.android_connection_count) {
                        androidConnectionCount = json.data.android_connection_count;
                    }
                    if (json.data.ios_connection_count) {
                        iosConnectionCount = json.data.ios_connection_count;
                    }
                    if (json.data.agent_connection_count) {
                        agentConnectionCount = json.data.agent_connection_count;
                    }
                    this.setState({
                        connectionCount: connectionCount,
                        todayNewUserCount: todayNewUserCount,
                        androidConnectionCount: androidConnectionCount,
                        iosConnectionCount: iosConnectionCount,
                        agentConnectionCount: agentConnectionCount,
                    })
                        // setTimeout(function () {
                        //     requestGetConnection()
                        // }, 3000)

                }
            })
            .catch(err => console.log(err));
    };
    reload = () => {
        // window.location.reload();
        this.requestGetConnection()
    };

    render() {
        const {connectionCount, todayNewUserCount, androidConnectionCount, iosConnectionCount, agentConnectionCount} = this.state;
        return (
            <Fragment>
                <div className='App-dashboard-outer'>
                <div className='App-dashboard' onClick={ (e) => {this.reload(e)}}>
                    <div className='active-user'>현재 접속자</div>
                    <div className='connection-count'>{connectionCount}</div>
                    <div className='active-user'>신규</div>
                    <div className='connection-count'>{todayNewUserCount}</div>
                    <div className='active-user'>iOS</div>
                    <div className='connection-count'>{iosConnectionCount}</div>
                    <div className='active-user'>안드로이드</div>
                    <div className='connection-count'>{androidConnectionCount}</div>
                    <div className='active-user'>PC</div>
                    <div className='connection-count'>{agentConnectionCount}</div>
                </div>
                </div>
            </Fragment>
        )
    }

}

export default RemotePage;
